import {
  Tooltip,
  MenuButton,
  PseudoBox,
  Spinner,
  Portal,
  MenuList,
  MenuItem,
  Menu,
  Flex,
  Divider,
  Text,
  PseudoBoxProps,
} from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import useLocaleText from 'components/useLocaleText'
import { Settings } from 'lucide-react'
import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'

interface ActionMenuProps {
  isLoading: boolean
  tooltipText: string
  optionsList: {
    label: string
    icon: React.ReactNode
    color?: string
    onClick: () => void
  }[]
  triggerProps?: PseudoBoxProps
}

export const ActionMenu = ({ isLoading, tooltipText, optionsList, triggerProps }: ActionMenuProps) => {
  const isRtl = useSelector(isRtlSelector)
  const t_tooltip = useLocaleText(tooltipText)
  return (
    <Menu>
      <Tooltip label={t_tooltip} placement="bottom" hasArrow aria-label={t_tooltip} zIndex={10000}>
        <MenuButton
          as={PseudoBox}
          borderRadius="5px"
          w="max-content"
          cursor="pointer"
          pos="absolute"
          top="10px"
          right="10px"
          _hover={{ background: 'colors.greyMedium2' }}
          p="5px"
          {...triggerProps}
        >
          {isLoading ? <Spinner size="sm" /> : <Settings size={18} />}
        </MenuButton>
      </Tooltip>

      <Portal>
        <MenuList minW="200px" placement="bottom-start">
          {optionsList.map(({ label, icon, onClick, color }, index) => (
            <Fragment key={index}>
              <MenuItem onClick={onClick}>
                <Flex
                  align="center"
                  color={color || 'inherit'}
                  flexDir={isRtl ? 'row-reverse' : 'row'}
                  style={{ columnGap: '10px' }}
                >
                  {icon}
                  <Text>
                    <LocaleText text={label} />
                  </Text>
                </Flex>
              </MenuItem>
              {index !== optionsList.length - 1 && <Divider />}
            </Fragment>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  )
}
